module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "downLoad",
    attrs: {
      "href": "~@img/Zoom_Getting Started with PC and MAC v6.pdf",
      "download": "ZOOM"
    }
  }, [_vm._v("ZOOM")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd722642"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/zoom.vue
// module id = 865
// module chunks = 1